<template>
  <div>
    <div>
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>库存管理</el-breadcrumb-item>
          <el-breadcrumb-item><span style="color:#000;font-weight:bold;">库存收发明细</span></el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <list-top :form="form" @search="search" class="list-top-margin" :goodsShow="true"></list-top>
      </div>
      <div class="white-background">
          <el-row class="tbl-btn">
            <el-col :span="12" class="tbl-btn-left">
              <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>
            </el-col>
          </el-row>
          <!--列表-->
          <el-table
          ref="tableData"
          size="small"
          :data="listData"
          show-summary
          :summary-method="getSummaries"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          element-loading-text="加载中"
          :header-cell-style="_headerStyle"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
          >
            <el-table-column align="left" :reserve-selection="true" type="selection" width="100">
            </el-table-column>
            <el-table-column align="left" type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column label="产品编号" >
              <template slot-scope="scope">
                <span class="txt-overflow">{{scope.row.productInfo?scope.row.productInfo.productCode:''}}</span>

              </template>
            </el-table-column>
            <el-table-column label="产品名称" >
              <template slot-scope="scope">
                <span>{{scope.row.productInfo?scope.row.productInfo.productName:''}}</span>
              </template>
            </el-table-column>
            <el-table-column label="产品规格" >
              <template slot-scope="scope">
                <span>{{scope.row.productInfo?scope.row.productInfo.specs:''}}</span>
              </template>
            </el-table-column>
            <el-table-column label="库存单位" >
              <template slot-scope="scope">
                <span>{{scope.row.productInfo?scope.row.productInfo.unit:''}}</span>
              </template>
            </el-table-column>
            <el-table-column sortable  label="库存变更数量" >
              <template slot-scope="scope">
                <span  v-if="scope.row.receiptType == '入库单'">{{scope.row.receiptNum}}</span>
                <span  v-if="scope.row.receiptType == '出库单'">{{"-" + scope.row.receiptNum}}</span>
              </template>
            </el-table-column>
            <el-table-column sortable prop="receiptNum" label="单据数量" >

            </el-table-column>
            <el-table-column prop="changedTime" label="库存收发时间" >
            </el-table-column>
            <el-table-column prop="receiptType"  label="来源单据类型">

            </el-table-column>

            <el-table-column prop="receiptCode" label="来源单据编号">

            </el-table-column>
            <el-table-column prop="stockType" label="库存类型">
            </el-table-column>

            <el-table-column prop="remark" label="备注" >
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" >
            </el-table-column>
            <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName">
              <template slot-scope="scope">
                <span v-if="item.fieldInfo.radioScope">{{item.fieldInfo.radioScope.filter(p=>p.checked)?item.fieldInfo.radioScope.filter(p=>p.checked)[0]['label']:''}}</span>
              </template>
            </el-table-column>



          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { instockGetList,instockDelete,instockBatchDelete,outinstockGetList} from '@/api/basicData';
import { queryAllCustomSet} from '@/api/business';

import Pagination from '@/components/Pagination';
import ListTop from './ListTop.vue';
import {exportDataToExcel} from '@/utils/util';

export default {
  watch:{
    tblSelectionList(newList,oldList){
      this.isBatchPrint = (newList && newList != null && newList.length > 0);

    }
  },
  data() {
    return {
      isBatchPrint:false,
      isSearchPanelShow:false,
      tblSelectionList:[],
      //--------------------------
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      form: {
      },
      listData: [{
        num:1,
        num1:2,
        code:'111'
      },{
        num:2,
        num1:4,
        code:'111'
      }], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      userData:{},
      mode:'',
      editRow:{},
      setList:[],

    }
  },
  // 注册组件
  components: {
    Pagination,
    ListTop
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    queryAllCustomSet(this.userData.factoryId,'outInStock').then(res=>{
      this.setList = [];
      if(res['code'] == 200){
        this.setList = res['data'];
        this.getdata();
      }
    })
   // this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        tableName:'库存收发明细',
        collection:'outInStock',
      }
      //params.condition[this.searchSelectValue] = this.searchInputValue

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "库存收发明细清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

    },
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
        item.receiptChangeNum = item.receiptType == '入库单'? item.receiptNum: '-' + item.receiptNum;
        item.productCode = item.productInfo?item.productInfo.productCode:'';
        item.productName = item.productInfo?item.productInfo.productName:'';
        item.specs = item.productInfo?item.productInfo.specs:'';
        item.unit = item.productInfo?item.productInfo.unit:'';
        for(let i = 0;i<this.setList.length;i++){
          if(this.setList[i].fieldInfo){

            item[this.setList[i]['fieldName']] = this.setList[i].fieldInfo.radioScope.filter(p=>p.checked)?this.setList[i].fieldInfo.radioScope.filter(p=>p.checked)[0]['label']:'';
          }
        }
      });
      return data;
    },
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){

        this.exportData();
        return;
      }
      const header = [
        "产品编号",
        '产品名称',
        '产品规格',
        '库存单位',
        '库存变更数量',
        '单据数量',
        '库存收发时间',
        '来源单据类型',
        '来源单据编号',
        '库存类型',
        '备注',
        '创建时间',

      ];
      const filterVal = [
        'productCode',
        'productName',
        'specs',
        'unit',
        'receiptChangeNum',
        'receiptNum',
        'changedTime',
        'receiptType',
        'receiptCode',
        'stockType',
        'remark',
        'createTime',

      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =this.filterTableData(JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"库存收发明细清册"+Date.now());
    },
    search(){
      this.pageparm.currentPage = 1
      this.pageparm.pageSize = 10
      this.getdata()
    },
    getdata() {
      console.log("form",this.form)
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      for(var key in this.form){
        if(this.form[key] && (this.form[key].length > 0 || this.form[key] >= 0)){
          if(key == 'productCode' || key == 'productName' || key == 'specs'){

            params.condition['productInfo' + '.' + key] = this.form[key];
          }else{
            params.condition[key] = this.form[key];
          }
        }
      }
      if(params.condition.changedTime){
        if(params.condition.instockTime == "between" && params.condition.changedTime.length == 2){
          params.condition.changedTime = {
            begin:this.form.changedTime[0].substring(0,10) + " 00:00:00",
            end:this.form.changedTime[1].substring(0,10) + " 23:59:59",
            type:this.form.instockTime,
            data:'time'
          }
        }else{
          params.condition.changedTime = {
            type:params.condition.instockTime,
            value:this.form.changedTime,
            data:'time'
          }
        }
      }
      delete params.condition.instockTime;
      outinstockGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    handleDelete(index,row){
      this.$confirm('确认删除入库单？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          instockDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          instockBatchDelete(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    //-------------------
    /**
     * 控制查询面板显示隐藏
     */
    expandClick(){
      this.isSearchPanelShow = !this.isSearchPanelShow;
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val){
      this.tblSelectionList = val;
    },
    exportDefault(){

    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }

          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // 控制哪些列展示合计
            if(column.property == 'num' ||column.property == 'num1' ){
              sums[index] = '合计' + sums[index];
            }else{
              sums[index] = '';
            }
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.el-divider--horizontal{
  margin: 10px 0px;
}
.date-picker{
  width: 100% !important;

}
.el-input__inner{
  height: 32px;
  line-height: 32px;
  padding: 0px 10px;
}
.el-form-item{
  margin-bottom: 10px;
}
.tbl-btn{
  width: 100%;
  height: 50px;
  line-height: 50px;

}
.tbl-btn .tbl-btn-right{
  text-align: right;
}
.tbl-pagination{
  text-align: right;
}
.txt-overflow{
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>





// WEBPACK FOOTER //
// src/views/stockManagement/stockRDDetail/StockRDDetail.vue